import {getCleanUrlSearchParamsEntries} from 'swayok-react-mdb-ui-kit/helpers/getCleanUrlSearchParamsEntries'
import type {
    FilteredItemsPageUrlQueryKnownParams,
    FilteredItemsPageUrlQueryParams,
    ItemsCategoryPropertyFiltersFormValues,
} from '../modules/public/ads/AdsModuleTypes'
import {decodeItemsSearchFiltersFromUrlQueryParam} from './decodeItemsSearchFiltersFromUrlQueryParam'
import {encodeItemsSearchFiltersForUrlQueryParam} from './encodeItemsSearchFiltersForUrlQueryParam'

/**
 * Изменяет URL query параметры для списка объявлений или услуг.
 * Сохраняет неизвестные параметры.
 * Удаляет параметры со значением null или пустой строкой.
 * Возвращает новый отсортированный массив пар ключ-значение,
 * подходящий для использования в new URLSearchParams(ret) или Object.fromEntries(ret).
 */
export async function modifyItemsSearchUrlQueryParams(
    urlQueryParams: FilteredItemsPageUrlQueryParams,
    newKnownParams: Partial<FilteredItemsPageUrlQueryKnownParams> = {},
    newFilters: ItemsCategoryPropertyFiltersFormValues = {}
): Promise<[string, string][]> {

    const {
        props: adPropsFilters = {},
        communicationMethod,
        ...filtersWithoutProps
    } = newFilters

    const newQueryParams: Record<keyof FilteredItemsPageUrlQueryKnownParams | string, unknown> = {
        ...urlQueryParams,
        ...newKnownParams,
        ...filtersWithoutProps,
        // Если способ связи не передан, сохраняем текущее значение из URL.
        ...('communicationMethod' in newFilters ? {cm: communicationMethod} : {}),
        f: await encodeItemsSearchFiltersForUrlQueryParam({
            ...(await decodeItemsSearchFiltersFromUrlQueryParam(urlQueryParams.f) ?? {}),
            ...adPropsFilters,
        }),
    }

    return getCleanUrlSearchParamsEntries(newQueryParams, true)
}

